import _ from "lodash";
import {log} from 'common/log';

function getError(evt: ProgressEvent<FileReader>) {
	const name = _.get(evt, ['target', 'error', 'name']);
	let message;
	switch (name) {
		case 'NotFoundError':
			message = 'Die Datei konnte nicht gefunden werden.';
			break;
		case 'NotReadableError':
			message = 'Die Datei ist nicht lesbar. Bitte Berechtigungen auf diese Datei prüfen.';
			break;
		case 'AbortError':
			message = null; // no error
			break;
		default:
			message = 'Unbekannter Fehler beim Lesen der Datei.';
			log.error(evt);
			break;
	}
	return message;
}

function extractProgress(evt: ProgressEvent<FileReader>) {
	if (evt.lengthComputable) {
		return evt.loaded / evt.total;
	} else {
		return 0;
	}
}

export function readFileToBase64(file?: File, progressCallback?: (percentage: number) => any): Promise<{ filename: string, mimeType: string, data: string }> {
	if (!file) return Promise.reject("Keine Datei ausgewählt");
	let onprogress: ((this: FileReader, ev: ProgressEvent<FileReader>) => any) | null = null
	if (progressCallback) onprogress = (evt) => progressCallback(extractProgress(evt));
	const filename = file.name;
	const mimeType = file.type;
	return new Promise((resolve, reject) => {
		const reader = new FileReader()
		reader.onerror = (evt) => reject(getError(evt))
		reader.onprogress = onprogress
		reader.onload = (evt) => resolve({filename, mimeType, data: btoa(evt.target?.result as string)})
		reader.readAsBinaryString(file)
	})
}

export function getSizeFromBase64(b64str: string) {
	const l = Math.ceil((b64str || '').length / 4) * 3
	return l + l % 4
}


export function base64ToDataURI(mimeType: string = 'text/plain', data?: string | number | null) {
	return data && `data:${mimeType};base64, ${data}` || ''
}